export default "__VITE_ASSET__4zx5B97Z__"